import get from 'lodash/get';
import ContentItemWithResolver from "models/ContentItemWithResolver";

export default class PartnersSection extends ContentItemWithResolver {
	get partnerLogos() {
		return get(this, '_partner_logo_links', []);
	}
}
